import React from 'react';
import {
  credits,
  marketMetaLine,
  marketTitle,
  scheduleLabel,
} from './nxlUtils';

function PositionsPanel({
  dashboard,
  positions,
  positionTab,
  setPositionTab,
  positionsLoading,
  loadPositions,
}) {
  const filteredPositions = positions.filter((p) => {
    if (positionTab === 'all') return true;
    if (positionTab === 'settled') return ['won', 'lost', 'void'].includes(p.result);
    return p.result === 'open';
  });

  return (
    <section className="nxl-panel">
      <div className="nxl-section-heading">
        <div>
          <p className="nxl-kicker">YOUR MARKET ACCOUNT</p>
          <h2>Positions</h2>
        </div>

        <button className="nxl-small-button" onClick={loadPositions}>
          Refresh
        </button>
      </div>

      <div className="nxl-modal-stats nxl-inline-stats">
        <div><span>Balance</span><strong>{credits(dashboard?.wallet?.balance)}</strong></div>
        <div><span>Open</span><strong>{dashboard?.positions?.open || 0}</strong></div>
        <div><span>Won</span><strong>{dashboard?.positions?.won || 0}</strong></div>
        <div><span>Lost</span><strong>{dashboard?.positions?.lost || 0}</strong></div>
      </div>

      <div className="nxl-position-tabs">
        <button className={positionTab === 'open' ? 'active' : ''} onClick={() => setPositionTab('open')}>Open</button>
        <button className={positionTab === 'settled' ? 'active' : ''} onClick={() => setPositionTab('settled')}>Settled</button>
        <button className={positionTab === 'all' ? 'active' : ''} onClick={() => setPositionTab('all')}>All</button>
      </div>

      {positionsLoading ? (
        <p className="nxl-muted">Loading positions…</p>
      ) : (
        <div className="nxl-position-list">
          {filteredPositions.map((position) => {
            const market = position.market || {};
            const pickedTeam = position.side === 'team_a' ? market.team_a : market.team_b;

            return (
              <div className="nxl-position-row" key={position._id}>
                <div>
                  <strong>{marketTitle(market)}</strong>
                  <span>Picked {pickedTeam}</span>
                  <small className="nxl-market-meta">
                    {scheduleLabel(market)}
                    {marketMetaLine(market) ? ` • ${marketMetaLine(market)}` : ''}
                  </small>
                </div>

                <div className="nxl-position-meta">
                  <span>{position.result}</span>
                  <strong>{credits(position.stake)} stake</strong>
                  <em>{credits(position.trading_fee)} fee</em>
                  <em>{credits(position.payout_if_correct)} quoted payout</em>
                </div>
              </div>
            );
          })}

          {!filteredPositions.length && (
            <p className="nxl-muted">No positions in this tab.</p>
          )}
        </div>
      )}
    </section>
  );
}

export default PositionsPanel;